<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Deployments history">
            <b-table striped hover :items="items"></b-table>
            <b-button v-if="permission > 2" variant="danger" @click.prevent="reDeploy">Force redeploy</b-button>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data () {
    return {
      deployData: [],
      items: [],
      confirm: false
    }
  },
  methods: {
    fetchDeploymentsData () {
      this.$http.get(this.api_url).then(data => {
        this.deployData = data.data.data.filtered.filter(item => item !== '')
      }).then(data => {
        this.formatTable()
      })
    },
    reDeploy () {
      this.confirm = prompt('Are you sure? Type "redeploy" if yes')
      if (this.confirm === 'redeploy') {
        this.$http.post(`${this.$api_url}/deploy/run/sfgsdfgsfdgsdywttrjywytetr`).then(response => {
          alert('Redeploy started! Please allow 2-3 minutes in order to complete!')
          this.confirm = false
        })
      }
    },

    formatTable () {
      const items = []
      let iteration = 1
      this.deployData.reverse().map(item => {
        return items.push({ '#': iteration++, Date: item })
      })
      this.items = items
    }
  },
  created () {
    this.api_url = `${this.$api_url}/deploy/history`
    this.fetchDeploymentsData()
  },
  computed: {
    ...mapGetters(['permission'])
  }

}
</script>

<style scoped>

</style>
